import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmedValidator } from '../confirmed.validator';
import { UtilitaService } from '../services/utilita.service';
import { Md5 } from "md5-typescript";
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-nuova-password',
  templateUrl: './nuova-password.component.html',
  styleUrls: ['./nuova-password.component.css']
})
export class NuovaPasswordComponent implements OnInit {
  frmInserimento!: FormGroup;
  lstAtenei: any;
  lstDipartimenti: any;
  lstRuolo: any;
  lstReferente: any;
  lstSettoreScientifico: any;

  codiceclientenew: number = -1;
  objclientenew: any;

  constructor(private fb: FormBuilder,
    private srvUtilita: UtilitaService, public authService: AuthService,
    private dialog: MatDialog, private router: Router,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {


    this.frmInserimento = this.fb.group({ //nuova password //tab3
      Email: ['', [Validators.required]],
      Password: ['', [Validators.required]],
    })

  //  AuthService.loggedIn = false;


  }






  btnNuovaPassword() {
    let objInserimento: any
    objInserimento = this.frmInserimento.value
    console.log('objInserimento', objInserimento)

    let objPassword: any
    objPassword = this.frmInserimento.value.Password;


    const obj = {
      Email: this.frmInserimento.value.Email,
      Password: Md5.init(objPassword),
      isVerificato: 0
    }
  
    console.log('obj', obj)

    this.srvUtilita.postObj('Login/PostPrimoAccesso', obj).subscribe((res: any) => {
      this.showMessage('Operazione avvenuta correttamente.', 'OK')
      this.router.navigate(['/login/'])
    }, (err: any) => {
      // console.log('Errore: I dati non sono stati inseriti in modo corretto');
     // this.showMessage('Errore: I dati non sono stati inseriti in modo corretto.', 'OK')
        this.showMessage(err.error.Message, 'OK');
    })
  }


  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }

}
